import { DropdownOptionIntegerId } from '@/models/DropdownOptionIntegerId';

export class PlatformFilterData {
    platforms: Array<DropdownOptionIntegerId>;
    dataOwners: Array<DropdownOptionIntegerId>;
}
